import { render, staticRenderFns } from "./TspTripItinerary.vue?vue&type=template&id=23a0a0b8"
import script from "./TspTripItinerary.vue?vue&type=script&lang=ts"
export * from "./TspTripItinerary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports